module.exports = __webpack_public_path__ + "img/douyin.74bf198c.png";